import React from "react";
import ArrowForwardSvg from "../../../components/svgComponents/ArrowForwardSvg";

const ConnectItem = ({ onHandleClick, imgLink, imgName, walletName }) => {
  return (
    <button
      type="button"
      onClick={onHandleClick}
      className="bg-white min-w-[258px] xs:min-w-[268px] border w-full border-deepBlue dark:border-none dark:bg-[#232234] flex justify-between items-center py-1 md:py-4 px-4  md:px-6 rounded-lg shadow-maxButtonShadow"
    >
      <div className="flex items-center gap-2 md:gap-4">
        <div className="w-15 h-15 flex justify-center items-center">
          <img
            src={imgLink}
            alt={imgName}
            width={"45px"}
            height={"45px"}
            className="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"
          />
        </div>
        <p className="text-black text-lg md:text-xl leading-6 dark:text-white">
          {walletName}
        </p>
      </div>
      <ArrowForwardSvg />
    </button>
  );
};

export default ConnectItem;
